<template>
  <div class="app">
    <div class="content">
      <div class="content-boxs" v-for="(item,index) in list" :key="index" @click="goPage(item)">
        <img :src="item.icon" class="grid-img" />
      </div>
    </div>
    <van-popup v-model="show" mode="center" :round="true">
      <div class="popup-content">
        <img src="@images/xxgk/close.png" class="close" @click="show = false" />
        <img src="@images/xxgk/dialog-top.png" style="width: 100%" mode="widthFix" />
        <div class="d-title">实名认证!</div>
        <div class="d-content">请您进行实名认证，认证后可查看认证的村/社区信息，快快行动起来吧！</div>
        <button class="d-button" @click="clickSmrzBtn">立即前往</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import FileMixin from '@/views/common/mixins/file-mixin.js'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import wx from 'weixin-js-sdk'
import { getAction } from '@/api/manage'
export default {
  mixins: [FileMixin, OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  data() {
    return {
      show: false,
      list:[
        {
          title:"随手拍",
          path:"/hmhq/ssp",
          icon:require("@assets/images/banner/ssp.png")
        },
        {
          title:"专家咨询",
          path:"/hmhq/zyzx",
          icon:require("@assets/images/banner/zjzx.png")
        },
        {
          title:"物业服务",
          path:"/hmhq/wyfw",
          icon:require("@assets/images/banner/wyfw.png")
        },
        {
          title:"问题墙·回音壁",
          path:"/hmhq/problem",
          icon:require("@assets/images/banner/wall.png")
        },
        {
          title:"矛盾纠纷",
          path:"/qzzx/mdjf",
          icon:require("@assets/images/banner/mdjf.png")
        }
      ]
    }
  },
  created() {
   
  },
  mounted() {
  },
  methods: {
    clickSmrzBtn() {
      this.xgAddr()
      this.$router.push({
        name: 'smrz',
      })
    },
    goPage(item){
      this.xgAddr()
      if (this.isSmrz()) {
        this.$router.push({
          path: item.path,
        })
      } else {
        this.show = true
      }
    }
  },
}
</script>

<style lang="less" scoped>
.app{
  width: 100%;
  height: 100vh;
  background: #f6f7f9;
}
.content{
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  &-boxs{
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0px;
    img{
      width: 100%;
    }
  }
}
.popup-content {
  width: 290px;
  height: 317px;
  position: relative;
}

.d-title {
  font-size: 18px;
  font-weight: 600;
  color: #3875f6;
  line-height: 25px;
  margin-top: 26px;
  text-align: center;
}

.d-content {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 18px;
  margin: 16px 24px 32px;
  text-align: center;
}
.d-button {
  width: 80%;
  height: 38px;
  line-height: 38px;
  background: #3875f6;
  color: #ffffff;
  font-size: 15px;
  border-radius: 38px;
  margin-left: 10%;
  border: none;
}

.close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.dz-img {
  width: 16px;
  height: 16px;
}
.dz-text {
  color: #3875f6;
  margin-left: 6px;
}

.dz-content {
  margin-top: 7px;
  height: auto;
  background: #f6f6f6;
  padding: 8px;
  position: relative;
}

.dz-t {
  color: #3875f6;
  margin-left: 10px;
  line-height: 18px;
}

.sjx {
  border-bottom: 8px solid #f6f6f6;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  width: 1px;
  margin-left: 10px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.lb {
  width: 15px;
  height: 14px;
  position: absolute;
  top: 13px;
  left: 12px;
}
</style>
